import styled from 'styled-components';
import { defaultTheme as theme } from '../../styles/theme';


export const Container = styled.div`
    background-color: ${theme.colors.white};
    flex: 1;
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${theme.colors.white};
`;

export const BoxImage = styled.div`
`;

export const TextLogo = styled.img`
    width: 60px;
    height: 60px;
`;

export const Logo = styled.img`
    width: 204.22;
    height: 109.15;
`;

export const LogoDesktop = styled.img`
    width: 200;
    height: 200;
`;

export const ContainerLogo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const TopImage = styled.img`
    width: 100%;
    height: 25%;
`;

export const BottomImage = styled.img`
    width: 100%;
    height: 15%;
`;

export const TopImageDesktop = styled.img`
    width: 100%;
    height: 15%;
`;

export const BottomDesktopImage = styled.img`
    width: 100%;
    height: 15%;
    opacity: 44%;
`;

export const SingInFormContainer = styled.div`
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background-color: #FFFFFF; */
    /* z-index: ${theme.layers.overlay4}; */
`;
